import Chart from 'chart.js'

$(function () {

  const el = document.getElementById('chart')
  const ctx = el.getContext('2d')
  const gradient = ctx.createLinearGradient(0, 0, 0, 400)
  gradient.addColorStop(0, 'rgba(0, 120, 195, 0.32)')
  gradient.addColorStop(1, 'rgba(0, 120, 195, 0)')

  const gradient2 = ctx.createLinearGradient(0, 0, 0, 400)
  gradient2.addColorStop(0, 'rgba(0, 180, 220, 0.5)')
  gradient2.addColorStop(1, 'rgba(0, 180, 220, 0)')

  const chartData = JSON.parse(el.getAttribute('data-chart'))

  const datasets = new Array();

  for ( let key in chartData.data ) {
    if ( key === 'transparent' ) {
      datasets.push(
        {
          data: chartData.data[key],
          backgroundColor: gradient,
          borderColor: '#0078C3',
          borderWidth: 2,
          pointBorderWidth: 1,
          pointHoverBorderWidth: 1,
          pointHitRadius: 60,
          pointRadius: 0,
          pointHoverRadius: 3,
          pointBackgroundColor: '#fff',
          pointBorderColor: '#0078C3'
        }
      )
    } else {
      datasets.push(
        {
          data: chartData.data[key],
          backgroundColor: gradient2,
          borderColor: '#00B4DC',
          borderWidth: 2,
          pointBorderWidth: 1,
          pointHoverBorderWidth: 1,
          pointHitRadius: 60,
          pointRadius: 0,
          pointHoverRadius: 3,
          pointBackgroundColor: '#fff',
          pointBorderColor: '#00B4DC'
        }
      )
    }
  }

  const chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: chartData.labels,
      datasets: datasets
    },
    options: {
      legend: {
        labels: {
          fontColor: '#BECAD7'
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        intersect: false
      },
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: 100,
            maxTicksLimit: 10,
            fontColor: '#BECAD7',
            fontSize: '12'
          },
          gridLines: {
            drawBorder: false
          }
        }],
        xAxes: [{
          ticks: {
            fontColor: '#BECAD7',
            fontSize: '12',
            paddingTop: 20,
          },
          gridLines: {
            drawBorder: false,
            display: false,
            tickMarkLength: 28
          }
        }]
      }
    }
  })

  const excludedYears = chartData?.excluded

  if (excludedYears && excludedYears.length) {
    
    chart.options.tooltips.callbacks = {
      label: function(tooltipItem, data) {
        const year = data.labels[tooltipItem.index];
        if (excludedYears.includes(year)) {
          return '';
        }
        const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
        const value = tooltipItem.yLabel;
        return value;
      }
    };
  
    chart.update();

  }


})